import { memo, useMemo } from "react";

import { TableContext } from "components/Table/Context";
import TableHead from "ds/components/Table/Head";
import { TableColumnMeta } from "ds/components/Table/types";
import useTypedContext from "hooks/useTypedContext";

import EnvironmentTableColumn from "./EnvironmentTableColumn";

const EnvironmentTableHeader = ({ tableId }: { tableId: string }) => {
  const { mergedColumnsConfig } = useTypedContext(TableContext);
  const columns = useMemo(
    () => Object.values(mergedColumnsConfig) as TableColumnMeta[],
    [mergedColumnsConfig]
  );

  return (
    <TableHead>
      {columns.map((column) => (
        <EnvironmentTableColumn
          key={`thead-column-${column.id}`}
          column={column}
          tableId={tableId}
        />
      ))}
    </TableHead>
  );
};

export default memo(EnvironmentTableHeader);
